import { atom } from 'jotai';
import { LoginStatus } from './AccountStore';
import { InkyApiV2 } from '../API/InkyApiV2';

export interface Page {
    url: string;
}

export const CurrentPage = atom<number>(0);
export const pagesAtom = atom<Page[]>([]);
export const comicIdAtom = atom<number | false>(false);

export const ReaderIsFullScreen = atom<boolean>(false);

export const UpdateCurrentPage = atom(
    (get) => get(CurrentPage),
    async (get, set, props: {publicationId: number; pageNumber: number}) => {
            set(CurrentPage, props.pageNumber);
            // Update in backend
            console.log("Comic for update is", props.publicationId);
            const updateBackend = await InkyApiV2.shared().UpdateReadingProgress(props.publicationId, props.pageNumber);
    }
);

export const FetchPage = atom(
    (get) => get(pagesAtom),
    async (get, set, pageNumber: number) => {
        const comicId = get(comicIdAtom);
        if(!comicId){return;}
        const page = await InkyApiV2.shared().GetComicPageUrl(comicId, pageNumber);

        const prev = get(pagesAtom);
        prev[pageNumber] = page;
        set(pagesAtom, prev);
    }
);

export const LoadReader = atom(
    (get) => get(pagesAtom),
    async (get, set, comicId) => {
        set(comicIdAtom, comicId);
        // Reset the pagesAtom
        set(pagesAtom, []);

        // TODO: Check if curpage is set in mycomics
        //set(CurrentPage, 0);

        const curPage = get(CurrentPage);

        // Load the current page
        await set(FetchPage, curPage);
        // TODO: Then preload surrounding pages.
        // TODO: Page n1, p1, n2, p2, n3, p3, n4, n5
        // ForNow: Load the 5 next pages
        await set(FetchPage, curPage + 1);
        await set(FetchPage, curPage + 2);
        await set(FetchPage, curPage + 3);
        await set(FetchPage, curPage + 4);
        await set(FetchPage, curPage + 5);

    }
);
